module.exports = __webpack_public_path__ + "media/images/emblems/Amsoldingen-coat_of_arms-f8402c9723ce5885fae00933875b4ac2.svg";